import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTie = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.4773 2.79712C15.4924 2.74102 15.5 2.68293 15.5 2.62454C15.4999 2.27954 15.2388 1.99995 14.9168 2H9.08346C9.02896 2 8.97475 2.00819 8.92239 2.02426C8.61288 2.11953 8.43405 2.46554 8.52292 2.79712L9.65759 7.05213L8.50355 18.1804C8.48404 18.3693 8.54566 18.5574 8.67103 18.6919L11.5877 21.8169C11.6969 21.9342 11.8454 22.0002 12.0001 22C12.1549 22.0002 12.3033 21.9342 12.4126 21.8169L15.3292 18.6919C15.4546 18.5574 15.5162 18.3693 15.4967 18.1804L14.3427 7.05213L15.4773 2.79712ZM14.1432 3.25L13.3104 6.375H10.6899L9.85711 3.25H14.1432ZM12.0001 20.4912L9.69415 18.0205L10.7724 7.625H13.2278L14.3061 18.0205L12.0001 20.4912Z",
		fill: "currentColor"
	})
});
export default SvgTie;
